import log from "loglevel";
import { dashboard } from "../../../telemetry/TraceLogging";
import { lazyLoadModule } from "../../lazyLoadModule";
import { WidgetApi } from "../orchestrator/WidgetApi";
const TelemetryModule = import(
/* webpackChunkName: "Telemetry-Chunk" */
"../../../telemetry/Telemetry");
export class WidgetInteractionsApi extends WidgetApi {
    constructor(widgetInstance) {
        super(widgetInstance);
        this._eventListeners = new Array();
    }
    addEventListener(listener) {
        this._eventListeners.push(listener);
    }
    removeEventListener(listener) {
        let index = this._eventListeners.indexOf(listener);
        if (index > -1) {
            this._eventListeners.splice(index, 1);
        }
    }
    onTitleInteracted() {
        this.fireEvent("titleInteracted");
    }
    onSettingsInteracted() {
        this.fireEvent("settingsInteracted");
    }
    onWidgetPositionUpdated() {
        log.info("onWidgetPositionUpdated[" +
            this._widgetInstance.widgetId +
            "]: col=" +
            this._widgetInstance.getWidgetProperty("column") +
            " pos=" +
            this._widgetInstance.getWidgetProperty("position"));
        this.fireEvent("widgetPositionUpdated");
    }
    fireEvent(name) {
        lazyLoadModule(TelemetryModule).then((Telemetry) => {
            Telemetry.logEvent(dashboard, "WidgetInteractionEvent", 16777216 /* productAndServicePerformance */, {
                eventType: name,
            });
        });
        for (let index = 0; index < this._eventListeners.length; index++) {
            if (this._eventListeners[index]) {
                this._eventListeners[index](name);
            }
        }
    }
}
